import { useTranslation } from 'react-i18next'

import { useAuth } from '@/features/user/hooks'
import { Button } from '@/shared/components/ui'

export const SemPerfilPage = () => {
  const { logout } = useAuth()
  const { t } = useTranslation('common')

  return (
    <div
      data-testid="sem-perfil-page"
      className="animate-in fade-in flex min-h-[80vh] flex-col items-center justify-center gap-8 p-4 duration-500"
    >
      <div className="relative mb-4 h-24 w-24 animate-pulse">
        <div className="bg-primary/10 absolute inset-0 animate-pulse rounded-full" />
        <div className="bg-primary/20 absolute inset-2 animate-pulse rounded-full" />
        <div className="bg-primary/30 absolute inset-4 animate-pulse rounded-full" />
        <div className="bg-primary/5 absolute inset-3 animate-ping rounded-full" />
      </div>
      <div className="max-w-2xl space-y-4 text-center">
        <h1 className="text-3xl font-bold tracking-tighter">{t('sem_perfil.titulo')}</h1>
        <p className="text-muted-foreground text-base">{t('sem_perfil.descricao')}</p>
      </div>

      <div className="flex w-full max-w-xs min-w-[200px] flex-col gap-4 sm:flex-row">
        <Button variant="default" className="w-full transition-all hover:scale-105" onClick={logout}>
          {t('sem_perfil.button')}
        </Button>
      </div>
    </div>
  )
}
